export default __webpack_public_path__ + "static/media/qr-code.cfc8faf2.png";